import { BaseDto } from "../base/baseDto.model"

export class PersonaGaranteDto extends BaseDto{
    public nroDocumento:string = ""
    public id_Garantia:number = 0

}
